module.exports = __webpack_public_path__ + "static/media/EMS-link.1564fcab.svg";